export default "__VITE_ASSET__27982579__"